import React from "react";
import { IconProp } from ".";
export default function FilterIcon(props: IconProp) {
    const { className, width = 20, height = 20, color} = props;
    return (
        <div>
            <svg className={className} xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 -960 960 960" width={width}><path d="M400-240v-80h160v80H400ZM240-440v-80h480v80H240ZM120-640v-80h720v80H120Z" fill={color}/></svg>
        </div>
    );
}
